// removed by extract-text-webpack-plugin
module.exports = {"component":"_1xLJeLnxEgums908Bur3Au"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderBar/HeaderBar.css
// module id = 1008
// module chunks = 0